export function getRandom(min, max){
    return Math.floor(Math.random() * (max - min)) + min
}

export function formatDate(date){
    var year = date.getFullYear(),
        month = date.getMonth() + 1,
        day = date.getDate(),
        hours = date.getHours(),
        minutes = date.getMinutes(),
        seconds = date.getSeconds()
    month = month < 10 ? '0' + month : month
    day = day < 10 ? '0' + day : day
    hours = hours < 10 ? '0' + hours : hours
    minutes = minutes < 10 ? '0' + minutes : minutes
    seconds = seconds < 10 ? '0' + seconds : seconds
    return year + '-' + month + '-' + day + ' ' + hours + ':' + minutes + ':' + seconds
}

export function getDateRange(months){
    var now = new Date()
    now.setDate(1)
    if(months){
        now.setMonth(now.getMonth() + months)
    }
    return [formatDate(new Date(now.getFullYear(), now.getMonth(), 1)).substr(0, 10), formatDate(new Date(now.getFullYear(), now.getMonth() + 1, 0)).substr(0, 10)]
}

export function getBeforeOrAfterDate(days){
    var now = new Date()
    now.setDate(now.getDate() + days)
    return formatDate(now).substr(0, 10)
}

export function formatIosTime(time){
    var regexp = new RegExp('-', 'g')
    return time.replace(regexp, '/')
}

export function getFirstDayOfMonth(date, time, months){
    date = date ? new Date(typeof(date) == 'string' ? formatIosTime(date) : date) : new Date()
    date.setDate(1)
    if(months){
        date.setMonth(date.getMonth() + months)
    }
    return formatDate(date).substring(0, 10) + (time ? ' ' + time : '')
}

export function dateShow(startTime){
    let startDate = new Date(startTime.substr(0, 4), startTime.substr(5, 2) - 1, startTime.substr(8, 2))
    let now = new Date()
    now = new Date(now.getFullYear(), now.getMonth(), now.getDate())
    let oneDay = 1000 * 60 * 60 * 24
    if((startDate - now) / oneDay == -1){
        return '昨天'
    }else if((startDate - now) / oneDay == 0){
        return '今天'
    }else if((startDate - now) / oneDay == 1){
        return '明天'
    }else if((startDate - now) / oneDay == 2){
        return '后天'
    }else{
        return startTime.substr(5, 2) + '/' + startTime.substr(8, 2)
    }
}

export function detectZoom() {
    var ratio = 0,   screen = window.screen, ua = navigator.userAgent.toLowerCase();
    if (window.devicePixelRatio !== undefined) {
        ratio = window.devicePixelRatio;
    } else if (~ua.indexOf('msie')) {
        if (screen.deviceXDPI && screen.logicalXDPI) {
            ratio = screen.deviceXDPI / screen.logicalXDPI;
        }
    } else if (window.outerWidth !== undefined && window.innerWidth !== undefined) {
        ratio = window.outerWidth / window.innerWidth;
    }
    if (ratio) {
        ratio = Math.round(ratio * 100);
    }
    return ratio;
}

export function copyToClipboard(content){
    let textArea = document.createElement('textarea')
    document.body.appendChild(textArea)
    textArea.value = content
    textArea.select()
    document.execCommand('copy')
    document.body.removeChild(textArea)
}

export function unique(arr){
    let newArr = []
    arr.forEach(item => {
        if(!newArr.includes(item)){
            newArr.push(item)
        }
    })
    return newArr
}

export function blobToJSON(blob){
    return new Promise((resolve, reject) => {
        let fr = new FileReader()
        fr.onload = function(){
            resolve(JSON.parse(this.result))
        }
        fr.readAsText(blob)
    })
}

export function isTimeConflict(timeSegment1, timeSegment2) {
    return timeSegment1[1] > timeSegment2[0] && timeSegment2[1] > timeSegment1[0]
}


// WEBPACK FOOTER //
// ./src/utils/index.js